<template>
    <div class="conversation-list">
      <div class="conversation-list-header">
        <h2>{{ aiType === 'painting' ? '绘画AI对话' : 
              aiType === 'chatGLM' ? 'ChatGLM对话' : 
              aiType === 'autoGLM' ? 'AutoGLM对话' : '对话列表' }}</h2>
        <button @click="createNewConversation" class="new-conversation-btn">
          新建对话
        </button>
      </div>
      
      <div class="conversation-items">
        <div 
          v-for="conversation in conversations" 
          :key="conversation.id"
          class="conversation-item"
          :class="{ active: isActive(conversation.id) }"
          @click="switchConversation(conversation.id)"
        >
          <div class="conversation-name">{{ conversation.name }}</div>
          <div class="conversation-meta">
            <span class="update-time">{{ formatTime(conversation.updatedAt) }}</span>
            <button 
              class="delete-btn" 
              @click.stop="deleteConversation(conversation.id)"
            >
              删除
            </button>
          </div>
        </div>
        
        <div v-if="conversations.length === 0" class="empty-state">
          暂无对话，点击"新建对话"开始
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      aiType: {
        type: String,
        required: true,
        validator: value => ['exercises', 'mexercises', 'pexercises', 'composition'].includes(value)
      }
    },
    
    computed: {
      conversations() {
        return this.$store.getters.conversationsByAiType(this.aiType);
      },
      
      activeConversationId() {
        return this.$store.getters.activeConversation?.id;
      }
    },
    
    methods: {
      isActive(conversationId) {
        return this.activeConversationId === conversationId;
      },
      
      async createNewConversation() {
        const aiTypeMap = {
          'painting': '绘画AI',
          'chatGLM': 'ChatGLM',
          'autoGLM': 'AutoGLM'
        };
        
        // const defaultName = `${aiTypeMap[this.aiType]}对话 ${new Date().toLocaleString()}`;
        // const name = prompt('请输入对话名称', defaultName);
           await this.$store.dispatch('createConversation', {
            aiType: this.aiType,
            
          });
        
        // if (name) {
        //   await this.$store.dispatch('createConversation', {
        //     aiType: this.aiType,
        //     name
        //   });
        // }
      },
      
      async switchConversation(conversationId) {
        await this.$store.dispatch('switchActiveConversation', conversationId);
      },
      
      async deleteConversation(conversationId) {
        if (confirm('确定要删除这个对话吗？')) {
          await this.$store.dispatch('deleteConversation', conversationId);
        }
      },
      
      formatTime(timeString) {
        const date = new Date(timeString);
        return date.toLocaleString();
      }
    }
  };
  </script>
  
  <style scoped>
  .conversation-list {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 16px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  
  .conversation-list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }
  
  .new-conversation-btn {
    padding: 6px 12px;
    background-color: #42b983;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .new-conversation-btn:hover {
    background-color: #359e75;
  }
  
  .conversation-items {
    flex: 1;
    overflow-y: auto;
  }
  
  .conversation-item {
    padding: 10px;
    border-radius: 4px;
    margin-bottom: 8px;
    cursor: pointer;
    transition: background-color 0.2s;
  }
  
  .conversation-item:hover {
    background-color: #f5f5f5;
  }
  
  .conversation-item.active {
    background-color: #eafaf1;
    border-left: 3px solid #42b983;
  }
  
  .conversation-name {
    font-weight: 500;
    margin-bottom: 4px;
  }
  
  .conversation-meta {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #666;
  }
  
  .delete-btn {
    color: #ff4d4f;
    background: none;
    border: none;
    cursor: pointer;
    padding: 2px 4px;
  }
  
  .delete-btn:hover {
    text-decoration: underline;
  }
  
  .empty-state {
    text-align: center;
    padding: 20px;
    color: #999;
    font-style: italic;
  }
  </style>
  